import React, { useState, useEffect, useRef, findDOMNode } from 'react';
import { UncontrolledAccordion, AccordionBody, AccordionHeader, AccordionItem, Badge } from 'reactstrap';
import './avattavaboxi.css'
import { Table } from 'reactstrap';
import axios from "axios"

function processAnswers(ans, points) {
  let newAns = []
  for (let a of ans) {
    if (a === "kiitoskiitos") {
      newAns.push("Peli suoritettu")
    } else if (a == "-1" && points == 0) {
      newAns.push(<b>Taso ohitettu :(</b>)
    } else if (a == "nice") {
      newAns.push("Pelaaja on suorittanut vaaditut toimenpiteet")
    } else if (a.constructor === Array) {
      newAns.push(a.join(", "))
    } else {
      newAns.push(a)
    }
  }
  return newAns
}

export default function AdminLevels(props) {


  if (!props.levels || props.levels.length == 0) return null;


  return (
    <div className="paperi" style={{ padding: "20px", width: "unset" }}>
      <UncontrolledAccordion>
        {[...Array(124).keys()].map((level) => {
          const levelData = props.levels[level];

          const usersInLevel = props.users.map(u => ({ username: u.username, avatar: u.avatar, level: u.level })).filter(u => u.level == level || (level == 0 && !u.level))

          const userAnswersAndPoints = props.users.filter(u => u.answers && u.answers[level]).map(u => ({ avatar: u.avatar, username: u.username, ans: u.answers[level], pointsLevel: u.pointHistory ? u.pointHistory[level] : 0 }))

          return (
            <AccordionItem key={level}>
              <AccordionHeader targetId={"level-" + level}>
                <span style={{ fontWeight: (levelData?.points > 0 ? "bold" : "normal") }}>{level}: {levelData ? levelData.title : ""}</span>
                {levelData && levelData.title && levelData.title.includes("Luukun") && levelData.title.includes("odotus") &&
                  <Badge pill style={{ marginLeft: "10px" }} color="danger">
                    <h6>Luukku {levelData.title.replace("Luukun", "").split(" ")[1]} alkaa</h6>
                  </Badge>
                }
                {levelData && levelData.points > 0 &&
                  <Badge pill style={{ marginLeft: "10px" }} color="success">
                    <h6>Pisteytettävä</h6>
                  </Badge>
                }
                {usersInLevel.length > 0 && <p style={{ marginLeft: "70px" }}>Pelaajat vaiheessa: </p>}
                {usersInLevel.map((u, i) => {
                  return (
                    <Badge style={{ marginLeft: "20px", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                      <img src={u.avatar} height={30} />
                      <h6 style={{ marginLeft: "10px" }}>{u.username}</h6>
                    </Badge>
                  )
                })}
              </AccordionHeader>
              <AccordionBody accordionId={"level-" + level}>
                {levelData && levelData.points === 0 && "Tästä vaiheesta ei ole lisää tietoa :("}
                {levelData && levelData.tries > 0 && <p>Yrityksiä: {levelData.tries}</p>}
                {levelData && levelData.points > 0 && <p>Maksimipisteet: {levelData.points}</p>}
                {levelData && levelData.correct.length > 0 && <p>Oikeat vastaukset: <ul>{processAnswers(levelData.correct, 1).map((a, i) => (<li key={i}>{a}</li>))}</ul></p>}
                {userAnswersAndPoints.length > 0 &&
                  (
                    <Table striped bordered variant="dark">
                      <thead>
                        <tr>
                          <th>Pelaaja</th>
                          <th>Vastaukset</th>
                          <th>Pisteet</th>
                        </tr>
                      </thead>
                      <tbody>
                        {userAnswersAndPoints.map((u, i) => (
                          <tr key={i}>
                            <td>
                              <img src={u.avatar} height={70} />
                              <span style={{ marginLeft: "10px" }}>{u.username}</span></td>
                            <td>
                              <ul>
                                {processAnswers(u.ans, u.pointsLevel || 0).map((a, j) => <li key={j}>{a}</li>)}
                              </ul>
                            </td>
                            <td>
                              {u.pointsLevel || 0}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )
                }
              </AccordionBody>
            </AccordionItem>
          )
        }

        )}
      </UncontrolledAccordion>
    </div >
  );

}
